import React, { useState, useEffect, useRef, useContext, memo, useLayoutEffect } from 'react';
import Select from 'react-select';
import './Configurator.css'; // Importa il file CSS per lo stile
import logo from './images/logo-idema.webp';

import sistemaCanalizzatoImg from './images/SISTEMA CANALIZZATO.jpg';
import sistemaMistoImg from './images/SISTEMA IMPIANTO MISTO.jpg';
import sistemaRadianteImg from './images/SISTEMA SOLO RADIANTE.jpg';
import distribuzioneImg from './images/DISTRIBUZIONE ARIA.jpg';
import motorizzatiImg from './images/ELEMENTI MOTORIZZATI.jpg';
import motorizzatiDistribuzioneImg from './images/ELEMENTI MOTORIZZATI E DISTRIBUZIONE ARIA.jpg';

import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Modal from 'react-modal';
import Switch from "react-switch";
import MyLoader from './components/MyLoader';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ReCAPTCHA from 'react-google-recaptcha';
import ConfiguratoreContextProvider, { ConfiguratoreContext } from './store/configuratore-context';
import ProgressBar from './components/ProgressBar';
//icone
import { BsArrowRightShort, BsArrowLeftShort, BsCheckLg } from "react-icons/bs";
import { IoArrowBack, IoArrowBackCircle, IoArrowForwardCircle, IoCheckmarkCircle, IoCheckmarkCircleOutline, IoClose, IoCloseCircle, IoCloseCircleOutline, IoCloseCircleSharp, IoMail, IoSave, IoSaveOutline, IoSnow, IoWarning } from "react-icons/io5";
import { FaLeaf, FaLightbulb, FaMobile, FaThermometer, FaThermometerThreeQuarters } from "react-icons/fa";
import SelezioneStacchi from './components/schema/SelezioneStacchi';
import Canvas from './components/canvas/Canvas';

const Configurator = () => {

    const canvasRef = useRef(null);

    //provvisorio per visualizzare portate kit
    const [kitProvvisorio, setKitProvvisorio] = useState('');

    //generali
    const [step, setStep] = useState(0); // Aggiunto lo stato per gestire i passi del configuratore
    const [totalSteps, setTotaleSteps] = useState(7);

    //costanti step per comodità
    const totalStepDis = 3;
    const totalStepMot = 3;
    const totalStepCompleto = 4;

    const [modalError, setModalError] = useState({
        flgModal: false,
        titolo: '',
        testo: '',
    });
    const [modalConferma, setModalConferma] = useState({
        flgModal: false,
        titolo: '',
        testo: '',
    });
    const [flgConf2, setFlgConf2] = useState(false); //flag che è true quando sono nella seconda configurazione
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const pathImmagini = "./images/immagini-articoli/";
    const [isLoading, setIsLoading] = useState(true);
    const [flgKitCompleto, setFlgKitCompleto] = useState(false); //flag che è true quando sono nella seconda configurazione

    //parametri da leggere passati da AppAgentiIdema
    const [paramCodAgente, setParamCodAgente] = useState(0);
    const [paramCodCliente, setParamCodCliente] = useState(0);
    const [paramSconto1, setParamSconto1] = useState(0);
    const [paramSconto2, setParamSconto2] = useState(0);
    const [paramSconto3, setParamSconto3] = useState(0);
    const [paramSconto4, setParamSconto4] = useState(0);
    const [paramSconto5, setParamSconto5] = useState(0);

    //context
    const configuratoreCtx = useContext(ConfiguratoreContext);

    //valori selezionati
    const [tipoSistema, setTipoSistema] = useState('canalizzato'); //FISSO X IDEMA
    const [kitCategory, setKitCategory] = useState('');
    const [productBrand, setProductBrand] = useState('');
    const [productModel, setProductModel] = useState('');
    const [diametroStacchi, setDiametroStacchi] = useState('');
    const [numberOfZones, setNumberOfZones] = useState(2);
    const [numTotaleStacchi, setNumTotaleStacchi] = useState(0);
    const [esteticaTerminale, setEsteticaTerminale] = useState('');
    const [tipoImpianto, setTipoImpianto] = useState('');
    const [coloreComandi, setColoreComandi] = useState('');
    const [tipoInterfaccia, setTipoInterfaccia] = useState('INFRAROSSO'); //FISSO X IDEMA
    const [stringaPathInterfaccia, setStringaPathInterfaccia] = useState('');
    const [codiceInterfaccia, setCodiceInterfaccia] = useState('');
    const [codicePlenum, setCodicePlenum] = useState('');
    const [flgPCAB, setFlgPCAB] = useState(2); //flag plenum cablato --> 0:NON SELEZIONATO; 1=SI; 2=NO  //FISSO X IDEMA
    const [flgPavimentoRadiante, setFlgPavimentoRadiante] = useState(false);
    const [numLocaliPavRadiante, setNumLocaliPavRadiante] = useState(2);
    const [flgKitSani, setFlgKitSani] = useState(false);

    //select marca e modello
    const [brandOptions, setBrandOptions] = useState([]);
    const [flgModelEnabled, setFlgModelEnabled] = useState(false);
    const [allModelOptions, setAllModelOptions] = useState([]);
    const [modelOptions, setModelOptions] = useState([]);

    //elenco portate dei KIT lette da DB
    const [portateKit, setPortateKit] = useState([]);
    const [alertPortataTerminale, setAlertPortataTerminale] = useState(false);
    const [alertNumStacchi, setAlertNumStacchi] = useState(false);

    //codici KIT
    const [codiciKIT, setCodiciKIT] = useState([]);

    //handle steps
    const handleNextStep = () => {
        setIsLoading(true);
        switch (step) {
            case 0:
                //MARCA E MODELLO
                if (productBrand == '' || productModel == '') {
                    setModalError({ flgModal: true, titolo: 'DATI INCOMPLETI', testo: 'Selezionare marca e modello per procedere.' });
                    setIsLoading(false);
                    return;
                } else break;
            case 1:
                //CATEGORIA KIT
                if (kitCategory == '') {
                    setModalError({ flgModal: true, titolo: 'DATI INCOMPLETI', testo: 'Selezionare una categoria per procedere.' });
                    setIsLoading(false);
                    return;
                } else {
                    flgKitCompleto ? setTotaleSteps(totalStepCompleto) : kitCategory == 'kitDistribuzione' ? setTotaleSteps(totalStepDis) : setTotaleSteps(totalStepMot);
                    break;
                }
            case 2:
                //NUMERO DI LOCALI/STACCHI
                fetchPortateKit();
                let totStacchi = calcolaNumeroTotaleStacchi();
                setNumTotaleStacchi(totStacchi);
                if (numberOfZones == 0 || totStacchi == 0) {
                    setModalError({ flgModal: true, titolo: 'DATI INCOMPLETI', testo: 'Selezionare il numero di locali e di stacchi procedere.' });
                    setIsLoading(false);
                    return;
                } else break;
            case 3:
                //kitMotorizzato: COMANDIE-->TERMINA; kitDistribuzione: ESTETICA TERMINALE-->TERMINA; kitCompleto: COMANDI ;
                if (kitCategory == 'kitMotorizzato' && (coloreComandi == '' || tipoImpianto == '')) {
                    setModalError({ flgModal: true, titolo: 'DATI INCOMPLETI', testo: 'Selezionare il KIT COMANDI per procedere.' });
                    setIsLoading(false);
                    return;
                } else if (kitCategory == 'kitDistribuzione' && esteticaTerminale == '') {
                    setModalError({ flgModal: true, titolo: 'DATI INCOMPLETI', testo: "Selezionare l'estetica del diffusore per procedere." });
                    setIsLoading(false);
                    return;
                } else {
                    handleSubmitConfiguratore();//SUBMIT ALLO STEP 5 SE --> kitDistribuzione ma in caso di flgConf2 (perchè KIT SANI l'ho già chiesto sul motorizzato)
                    setIsLoading(false);
                    break;
                }
            case 4:
                //kitCompleto: ESTETICA TERMINALE --> TERMINA;
                if (esteticaTerminale == '') {
                    setModalError({ flgModal: true, titolo: 'DATI INCOMPLETI', testo: "Selezionare l'estetica del diffusore per procedere." });
                    setIsLoading(false);
                    return;
                } else if (flgKitCompleto) {
                    handleSubmitConfiguratore();//SUBMIT ALLO STEP 5 SE --> kitDistribuzione ma in caso di flgConf2 (perchè KIT SANI l'ho già chiesto sul motorizzato)                    
                    return;
                } else break;
            case 100:
                //SALVA PREVENTIVO


                return;
            case 101:
                setStep(0);
        }
        setStep(step + 1);
        setTimeout(function () {
            setIsLoading(false);

            // Il codice che vuoi eseguire dopo l'attesa
        }, 750);
    };


    const handlePreviousStep = () => {
        // Rimuovi le scelte fatte nello step corrente
        setIsLoading(true);
        if (step === 0) {
            setProductModel('');
            return;
        } else if (step === 1) {
            setKitCategory('');
        } else if (step === 2) {
            setNumberOfZones(2);
            setNumTotaleStacchi(0);
            configuratoreCtx.setStacchiCtx({
                zona1: 1,
                zona2: 1,
                zona3: 1,
                zona4: 1,
                zona5: 1,
                zona6: 1,
            });
        } else if (step === 3) {
            setTipoImpianto('');
            setColoreComandi('');
            setAlertPortataTerminale(false);
            setEsteticaTerminale('');
        } else if (step === 4) {
            setAlertPortataTerminale(false);
            setEsteticaTerminale('');
            setCodiciKIT([]); //azzero tutti i codici kit se no se una va avanti e torna indietro aggiunge più volte
        }
        setStep(step - 1);
        setTimeout(function () {
            setIsLoading(false);
            // Il codice che vuoi eseguire dopo l'attesa
        }, 500);
    };

    //caricamento dati necessari
    const fetchMarcheModelli = () => {
        var data = {
            'op': 'getMarcheModelli',
        };
        return (
            fetch('https://configuratore-dev.csd-hosting.it/server/index.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(responseJson => {
                    // Chiudi la modal di caricamento
                    if (responseJson.status === false) {
                        // Gestisci eventuali errori
                    }
                    setBrandOptions(responseJson.marche);
                    setAllModelOptions(responseJson.modelli);
                    //IMPOSTO FISSO MARCA IDEMA E MODELLI IDEMA
                    setProductBrand({ value: 'IDEMA', label: 'IDEMA' });
                    let newModelOptions = responseJson.modelli.filter(model => model.marca == 'IDEMA');
                    setModelOptions(newModelOptions);
                    setFlgModelEnabled(true);
                    setProductModel('');
                    return;
                })
                .catch(error => {
                    console.log(error);
                    // Gestisci eventuali errori
                })
        );
    }

    const fetchPortateKit = () => {
        var data = {
            'op': 'getPortateKit',
        };
        return (
            fetch('https://configuratore-dev.csd-hosting.it/server/index.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(responseJson => {
                    // Chiudi la modal di caricamento
                    if (responseJson.status === false) {
                        // Gestisci eventuali errori
                    }
                    setPortateKit(responseJson.portateKit);
                    return;
                })
                .catch(error => {
                    console.log(error);
                    // Gestisci eventuali errori
                })
        );
    }

    //funzioni grafiche
    const handleWindowResize = () => {
        setWindowWidth(window.innerWidth);
        setWindowHeight(window.innerHeight);
    };

    const selectErrorStyle = {
        control: (base, state) => ({
            ...base,
            borderColor: "#fca8a8",
            background: "#fdeded",
        }),
        menu: base => ({
            ...base,
            // override border radius to match the box
            borderRadius: 0,
            // kill the gap
            marginTop: 0
        }),
        menuList: base => ({
            ...base,
            // kill the white space on first and last option
            padding: 0
        })
    };

    useEffect(() => {

        setIsLoading(true);

        fetchMarcheModelli();

        //lettura parametri passati da AppAgenti IDEMA
        const searchParams = new URLSearchParams(window.location.search);
        setParamCodAgente(searchParams.get('codAgente'));
        setParamCodCliente(searchParams.get('codCliente'));
        setParamSconto1(searchParams.get('sconto1'));
        setParamSconto2(searchParams.get('sconto2'));
        setParamSconto3(searchParams.get('sconto3'));
        setParamSconto4(searchParams.get('sconto4'));
        setParamSconto5(searchParams.get('sconto5'));

        window.addEventListener('resize', handleWindowResize);

        setTimeout(function () {
            setIsLoading(false);
        }, 1000);

        // Clean up: rimuovi l'event listener quando il componente viene smontato
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };


    }, []);

    //controllo alert numero di stacchi
    useLayoutEffect(() => {
        let stacchiCalcolati = calcolaNumeroTotaleStacchi();
        if (stacchiCalcolati < 3 && productModel.portataMax > 1100) setAlertNumStacchi(true);
        else setAlertNumStacchi(false);
    }, [configuratoreCtx.stacchi])

    const LazyImageMemo = memo(({ src, alt }) => {
        return <LazyLoadImage effect='blur' src={src} alt={alt} className="label-image" />;
    });

    //array delle opzioni menu a tendina
    const numberOfZonesOptions = [
        { value: '2', label: '2 LOCALI', img: pathImmagini + '4zone.jpg' },
        { value: '3', label: '3 LOCALI', img: pathImmagini + '6zone.jpg' },
        { value: '4', label: '4 LOCALI', img: pathImmagini + '4zone.jpg' },
        { value: '5', label: '5 LOCALI', img: pathImmagini + '4zone.jpg' },
        { value: '6', label: '6 LOCALI', img: pathImmagini + '6zone.jpg' },
    ];

    const handleKitCategoryChange = (value) => {
        //se è un kit completo lascio kitCategory = motorizzato e setto il flgKitCompleto a true
        if (value == 'kitCompleto') {
            value = 'kitMotorizzato';
            setFlgKitCompleto(true);
            configuratoreCtx.setFlgPlenumCtx(true);
        } else {
            setFlgKitCompleto(false);
        }
        setKitCategory(value);

        if (value == 'kitDistribuzione')
            configuratoreCtx.setFlgPlenumCtx(true);
    };

    const handleModelChange = (selectedOption) => {
        setProductModel(selectedOption);
        setCodiceInterfaccia(selectedOption.interfaccia);
        setCodicePlenum(selectedOption.plenum);
    };

    const handleNumberOfZonesChange = (selectedOption) => {
        let stacchiCalcolati = calcolaNumeroTotaleStacchi();
        if (stacchiCalcolati < 3 && productModel.portataMax > 1100) setAlertNumStacchi(true);
        else setAlertNumStacchi(false);

        setNumberOfZones(selectedOption.value);
        //setto anche le zone di default del pavimento radiante
        setNumLocaliPavRadiante(selectedOption.value);
    };

    const handleEsteticaTerminaleChange = (value) => {
        if (checkPortataTerminale(value) || productBrand.value == 'NON DEFINITA') {
            setAlertPortataTerminale(false);
        } else {
            setAlertPortataTerminale(true);
        }
        setEsteticaTerminale(value);
        checkPortataTerminaleProvvisorio(value);
    };

    const handleComandiChange = (valueColore, valueImpianto) => {
        setColoreComandi(valueColore);
        setTipoImpianto(valueImpianto);
    };

    const checkPortataTerminaleProvvisorio = (terminalType) => {

        const availableSizes = ['150', '200'];
        let closestKit = null;
        let closestDifference = Infinity;
        let desKitProvvisorio = '';

        for (const size of availableSizes) {
            const kitCode = `${numTotaleStacchi}KITDIS-${terminalType}-${size}`;
            const kit = portateKit.find(kit => kit.CodArt === kitCode);
            desKitProvvisorio = desKitProvvisorio + " KIT " + size + "  : " + kit.CodArt + " - Portata: " + kit.Portata;


        }

        setKitProvvisorio(desKitProvvisorio);
    }

    //controllo portata kit in confronto a portata macchina
    const checkPortataTerminale = (terminalType) => {

        const availableSizes = ['150', '200'];
        let closestKit = null;
        let closestDifference = Infinity;

        for (const size of availableSizes) {
            const kitCode = `${numTotaleStacchi}KITDIS-${terminalType}-${size}`;
            const kit = portateKit.find(kit => kit.CodArt === kitCode);

            if (kit) {
                // Controllo sulla portata
                const kitPortata = kit.Portata;
                const portataMin = productModel.portataMax * 0.8;
                const portataMaxThreshold = productModel.portataMax * 1.2;

                if (kitPortata >= portataMin && kitPortata <= portataMaxThreshold) {
                    const difference = Math.abs(productModel.portataMax - kitPortata);
                    if (difference < closestDifference) {
                        closestKit = kit.CodArt;
                        closestDifference = difference;
                    }
                }
            }
        }


        return closestKit;
    }

    //controllo portata kit in confronto a portata macchina
    const determinaKitDistribuzione = (terminalType) => {

        //con modello macchina non definita ritorno il kit dimensione stacchi scelta
        if (productModel.value == 'NON DEFINITO') return `${numTotaleStacchi}KITDIS-${terminalType}-${diametroStacchi.value}`;

        const availableSizes = ['150', '200'];
        let closestKit = null;
        let closestDifference = Infinity;

        for (const size of availableSizes) {
            const kitCode = `${numTotaleStacchi}KITDIS-${terminalType}-${size}`;
            const kit = portateKit.find(kit => kit.CodArt === kitCode);
            if (kit) {
                // Controllo sulla portata
                const kitPortata = kit.Portata;
                const difference = Math.abs(productModel.portataMax - kitPortata);
                if (difference < closestDifference) {
                    closestKit = kit.CodArt;
                    closestDifference = difference;
                }
            }
        }
        return closestKit;
    }

    //DIMENSIONE SERRANDA ASSOCIATA AL KIT MOTORIZZATO PIU' VICINA POSSIBILE ALLA PORTATA MACCHINA
    const determinaDimensioneSerranda = (tipoKitMotorizzato) => {

        //con modello macchina non definita ritorno dimensione stacchi scelta
        if (productModel.value == 'NON DEFINITO') return diametroStacchi.value;

        const availableSizes = [150, 200];
        let closestKitSize = null;
        let closestDifference = Infinity;

        for (const size of availableSizes) {
            const kitCode = `${numTotaleStacchi}${tipoKitMotorizzato}-CDZ-${size}-CFI`;
            const kit = portateKit.find(kit => kit.CodArt === kitCode);
            if (kit) {
                const difference = Math.abs(productModel.portataMax - kit.Portata);
                if (difference < closestDifference) {
                    closestKitSize = size;
                    closestDifference = difference;
                }
            }
        }

        return closestKitSize;
    };

    //DETERMINAZIONE CODICE KIT
    const determinaCodiceKIT = () => {

        let codiceKIT = '';

        if (kitCategory == 'kitMotorizzato') {
            let codIntSelezionata = '';
            if (tipoInterfaccia == 'FILO') codIntSelezionata = 'CFI';
            else if (tipoInterfaccia == 'INFRAROSSO') codIntSelezionata = 'CIR';
            else if (tipoInterfaccia == 'FANCOIL') codIntSelezionata = 'GTP';
            else if (tipoInterfaccia == 'NO') codIntSelezionata = 'NOINT'; //VEDERE COME GESTIRE

            if (flgPCAB == 1) {
                codiceKIT = numTotaleStacchi + "PCAB-CDZ-" + determinaDimensioneSerranda("PCAB") + "-" + codIntSelezionata;
            } else {
                codiceKIT = numTotaleStacchi + "PSC-CDZ-" + determinaDimensioneSerranda("PSC") + "-" + codIntSelezionata;
            }
        } else if (kitCategory == 'kitDistribuzione') {
            codiceKIT = determinaKitDistribuzione(esteticaTerminale);
        }
        const kitEsistente = portateKit.some(kit => kit.CodArt === codiceKIT);

        if (kitEsistente) {
            return codiceKIT;
        } else {
            return false;
        }
    }

    const determinaCodiceKITComandi = () => {

        let codiceKIT = '';

        if (kitCategory == 'kitMotorizzato') {
            if (flgPavimentoRadiante) {
                let numLocaliKitComandi = numLocaliPavRadiante >= numberOfZones ? numLocaliPavRadiante : numberOfZones;
                if (coloreComandi == 'bianchi' && tipoImpianto == 'RADIO') codiceKIT = numLocaliKitComandi + "COM-R-B";
                if (coloreComandi == 'bianchi' && tipoImpianto == 'FILO') codiceKIT = numLocaliKitComandi + "COM-F-B";
                if (coloreComandi == 'neri' && tipoImpianto == 'RADIO') codiceKIT = numLocaliKitComandi + "COM-R-N";
                if (coloreComandi == 'neri' && tipoImpianto == 'FILO') codiceKIT = numLocaliKitComandi + "COM-F-N";
            } else {
                if (coloreComandi == 'bianchi' && tipoImpianto == 'RADIO') codiceKIT = numberOfZones + "COM-R-B";
                if (coloreComandi == 'bianchi' && tipoImpianto == 'FILO') codiceKIT = numberOfZones + "COM-F-B";
                if (coloreComandi == 'neri' && tipoImpianto == 'RADIO') codiceKIT = numberOfZones + "COM-R-N";
                if (coloreComandi == 'neri' && tipoImpianto == 'FILO') codiceKIT = numberOfZones + "COM-F-N";
            }
        }

        const kitEsistente = portateKit.some(kit => kit.CodArt === codiceKIT);

        if (kitEsistente) {
            return codiceKIT;
        } else {
            return false;
        }
    }

    const calcolaNumeroTotaleStacchi = () => {
        let totaleStacchi = 0;
        for (let i = 1; i <= numberOfZones; i++) {
            totaleStacchi += +configuratoreCtx.stacchi[`zona${i}`];
        }
        return totaleStacchi;
    };

    // Funzione per aggiungere nuovi codici KIT all'array
    const aggiungiCodiciKIT = (nuoviCodici) => {

        let newCodici = codiciKIT;
        for (let i = 0; i < nuoviCodici.length; i++) {
            newCodici.push(nuoviCodici[i]);
        }

        //PER IDEMA DISATTIVATA COMANDA SEMPRE IL KITDISTRIBUZIONE
        //se è la configurazione 2 controllo che i due KIT non abbiano dimensioni discordanti (150, 200)
        //nel caso siano discordanti porto il 150 a 200
        //due KIT sono discordanti se uno contiene la stringa '150' e l'altro contiene la stringa '200'
        /*if (flgConf2) {
            const has150 = newCodici.some(codice => codice.includes('-150'));
            const has200 = newCodici.some(codice => codice.includes('-200'));
            if (has150 && has200) {
                newCodici = newCodici.map(codice => codice.replace('-150', '-200'));
            }
        }*/

        setCodiciKIT(newCodici);
    };

    //submit
    const handleSubmitConfiguratore = () => {

        //determinazione del KIT principale
        let codiceKIT = determinaCodiceKIT();

        //determinazione del KIT comandi
        let codiceKITComandi = determinaCodiceKITComandi();

        if (codiceKIT == false) {
            setModalError({ flgModal: true, titolo: 'ERRORE', testo: "Errore nella determinazione del codice KIT." });
            return;
        }
        if (codiceKITComandi == false && kitCategory == 'kitMotorizzato') {
            setModalError({ flgModal: true, titolo: 'ERRORE', testo: "Errore nella determinazione del codice KIT COMANDI." });
            return;
        }


        if (codiceKITComandi) {
            aggiungiCodiciKIT([codiceKIT, codiceKITComandi]);
        } else {
            aggiungiCodiciKIT([codiceKIT]);
        }

        console.log(codiciKIT);

        if (kitCategory == 'kitMotorizzato' && flgKitCompleto) {
            //se KIT COMPLETO vado diretto alla configurazione 2
            handleConfigurazione2();
            setIsLoading(false);
        } else {
            fetchSalvaPreventivo();
        }

    };

    const handleConfigurazione2 = () => {
        //setto il flag e chiudo il modal
        setFlgConf2(true);

        //salvo la categoria corrente
        let kitCategoryCorrente = kitCategory;

        //reset valori per configurazione impianto di tipo inverso
        if (kitCategory == 'kitMotorizzato') {
            setKitCategory('kitDistribuzione');
        } else if (kitCategory == 'kitDistribuzione') {
            setKitCategory('kitMotorizzato');
        } else return false;
        /* VEDERE COSA FARE PER PULIZIA VALORI %%%%%*/

        const scrollToElement = document.getElementById('app');
        if (scrollToElement) {
            scrollToElement.scrollIntoView({ behavior: 'smooth' });
        }

        if (kitCategoryCorrente == 'kitMotorizzato') {
            setStep(5);
        } else if (kitCategoryCorrente == 'kitDistribuzione') {
            setStep(5);
        } else return false;
    }


    //salva preventivo
    const fetchSalvaPreventivo = () => {
        setIsLoading(true);
        let dataURL = '';
        if (kitCategory == 'kitMotorizzato' || flgConf2) {
            dataURL = canvasRef.current.exportCanvas();
        }

        //AGGIUSTAMENTO DIMENSIONI KIT --> PER IDEMA PREVALE SEMPRE LA DIMENSIONE DELLA DISTRIBUZIONE
        let codiciKitCorretti = codiciKIT;
        if (flgKitCompleto) {
            // Lettura della dimensione dal kit distribuzione (es. "150" o "200")
            const codiceDistribuzione = codiciKIT.find(c => c.includes("KITDIS"));
        
            if (codiceDistribuzione) {
                const dimensioneDistribuzione = codiceDistribuzione.includes("200") ? "200" : "150";
        
                // Modifica dei codici PSC per uniformare la dimensione
                codiciKitCorretti = codiciKIT.map(codice => {
                    if (codice.includes("PSC")) {
                        // Sostituisce solo l'ultima occorrenza di 150 o 200
                        return codice.replace(/(150|200)(?!.*(150|200))/, dimensioneDistribuzione);
                    }
                    return codice;
                });
            }
        }

        var data = {
            'op': 'salvaPreventivo',
            'codAgente': paramCodAgente,
            'codCliente': paramCodCliente,
            'sconto1': paramSconto1,
            'sconto2': paramSconto2,
            'sconto3': paramSconto3,
            'sconto4': paramSconto4,
            'sconto5': paramSconto5,
            'CodiceKIT': '',
            'CodiciKIT': codiciKitCorretti,
            'numTotaleStacchi': numTotaleStacchi,
            'CodicePlenum': codicePlenum,
            'CodiceGriglia': productModel.CodiceGriglia,
            'CodiceGrigliaS': productModel.CodiceGrigliaS,
            'kitCategory': kitCategory,
            'flgKitCompleto': flgKitCompleto ? 1 : 0,
            'Marca': productBrand.value,
            'Modello': productModel.value,
            'elencoComponenti': [],
            'flgConf2': flgConf2 ? 1 : 0,
            'canvasImage': dataURL // Add the Base64 image data here
        };
        return (
            fetch('https://configuratore-dev.csd-hosting.it/server/index.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(responseJson => {
                    if (responseJson.status === false) {
                        if (responseJson.errorMail == true) {
                            setModalError({ flgModal: true, titolo: 'ERRORE INVIO E-MAIL', testo: "Controllare l'indirizzo e-mail inserito" });
                        } else {
                            setModalError({ flgModal: true, titolo: 'ERRORE', testo: 'Errore in fase di inserimento preventivo.' });
                        }
                    } else {
                        window.location.href = "https://configuratore-idema.csd-hosting.it/?success=true&idPrevConf=" + responseJson.idPreventivo;
                        setIsLoading(false);
                    }
                    return;
                })
                .catch(error => {
                    console.log(error);
                    setIsLoading(false);
                    // Gestisci eventuali errori
                })
        );
    }

    const closeModalConferma = () => {
        window.location.reload(); // Esegui il refresh della pagina
    };


    const scrollableElementRef = useRef(null);
    useEffect(() => {
        /*
        if (scrollableElementRef.current) {
          scrollableElementRef.current.scrollTo(0, 0);
        }*/
        const scrollToElement = document.getElementById('app');
        if (scrollToElement) {
            scrollToElement.scrollIntoView({ behavior: 'smooth' });
        }
    }, [step]);


    const ComandiChoice = ({ commandColor, impiantoType }) => {
        return (
            <div className={coloreComandi === commandColor && tipoImpianto == impiantoType ? 'radio-option first-option elevation-2' : 'radio-option first-option'}
                onClick={handleComandiChange.bind(this, commandColor, impiantoType)}>
                <div className='option-image-container'>
                    <img
                        effect='blur'
                        src={require(pathImmagini + "K" + commandColor.substring(0, 1).toUpperCase() + "_ETERNAL-SMART.jpg")}
                        alt={commandColor}
                        className="label-image"
                    />
                </div>
                <div className="label-container">
                    <label className="title-label">
                        <input
                            type="radio"
                            name="comandi"
                            value={commandColor + " - " + impiantoType}
                            checked={coloreComandi === commandColor && tipoImpianto == impiantoType}
                            onChange={handleComandiChange.bind(this, commandColor, impiantoType)}
                            className="input-radio"
                        />{impiantoType} {commandColor.toUpperCase().replace('BIANCHI', 'BIANCO').replace('NERI', 'NERO')}</label>
                </div>
            </div>
        );
    }

    const TerminalSelection = ({ }) => {

        const terminalTypes = ["BMA", "DLF", "PSB", "PSD", "PSF"];

        // Filtra e ordina i terminali -- MECCANISMO CHE METTE PER PRIMI I CONSIGLIATI RIMOSSO
        /*const recommendedTerminals = terminalTypes.filter(type => checkPortataTerminale(type));
        const nonRecommendedTerminals = terminalTypes.filter(type => !checkPortataTerminale(type));*/
        const recommendedTerminals = ["PSB", "PSD", "PSF"];
        const nonRecommendedTerminals = ["BMA", "DLF"];
        const sortedTerminals = [...recommendedTerminals, ...nonRecommendedTerminals];

        // Divide i terminali in due gruppi
        const firstGroup = sortedTerminals.slice(0, 3);
        const secondGroup = sortedTerminals.slice(3);

        return (
            <div>
                <div className='guida-utente' style={{ textAlign: 'center' }}>
                    DIFFUSORI CON STACCO POSTERIORE per eventuali modifiche alla posizione dello stacco, segnalare in fase d’ordine
                </div>
                <div className='radio-group'>
                    {firstGroup.map((terminalType, index) => (
                        <TerminalChoice
                            key={index}
                            terminalType={terminalType}
                        />
                    ))}
                </div>
                <div className='guida-utente' style={{ textAlign: 'center' }}>
                    Per l’installazione a muro, segnalare in fase d’ ordine. NB: codici e prezzi degli articoli potrebbero essere soggetti a variazioni.
                </div>
                <div className='radio-group'>
                    {secondGroup.map((terminalType, index) => (
                        <TerminalChoice
                            key={index + firstGroup.length}
                            terminalType={terminalType}
                        />
                    ))}
                </div>
                {
                    false &&
                    <>
                        <div>Portata Macchina : {productModel.portataMax}</div>
                        <div>{kitProvvisorio}</div>
                    </>
                }
            </div>
        )
    };

    const TerminalChoice = ({ terminalType }) => {
        return (
            <div className={esteticaTerminale === terminalType ? 'radio-option elevation-2' : 'radio-option'} onClick={handleEsteticaTerminaleChange.bind(this, terminalType)}>
                <div className='option-image-container'>
                    <img
                        effect='blur'
                        src={require(pathImmagini + terminalType + ".jpg")}
                        alt={terminalType}
                        className="label-image"
                    />
                </div>
                <div style={{ display: "flex", justifyContent: 'center' }}>
                    {
                        false && //DISATTIVATO BADGE SCELTA CONSIGLIATA
                        checkPortataTerminale(terminalType) && terminalType != "BMA" && terminalType != "DLF" && //SU TERMINALI NON DI PRODUZIONE INTERNA MAI SCELTA CONSIGLIATA
                        <div className='recommended-choice'>
                            <IoCheckmarkCircle className="check-icon" />
                            Scelta consigliata
                        </div>
                    }
                </div>
                <div className="label-container">
                    <label className="title-label">
                        <input
                            type="radio"
                            name="esteticaTerminale"
                            value={terminalType}
                            checked={esteticaTerminale === terminalType}
                            onChange={handleEsteticaTerminaleChange.bind(this, terminalType)}
                            className="input-radio"
                        />{terminalType}</label>
                </div>
                <div className='label-text'>
                    {
                        terminalType == 'PSB' ? 'Plenum bocchetta a scomparsa'
                            : terminalType == 'PSD' ? 'Plenum diffusore a scomparsa'
                                : terminalType == 'PSF' ? 'Plenum feritoia a scomparsa'
                                    : terminalType == 'BMA' ? 'Bocchetta a doppia deflessione'
                                        : terminalType == 'DLF' ? 'Diffusore lineare'
                                            : null
                    }
                </div>

            </div>
        );
    }

    //RENDER PRINCIPALE CONFIGURATORE
    const renderStepContent = () => {
        switch (step) {
            case 0:
                return (
                    <div className="configurator-step">
                        <h3>SELEZIONA IL MODELLO DELLA MACCHINA CANALIZZATA</h3>
                        <div className='select-group' style={windowWidth < 1200 ? { flexDirection: 'column' } : null}>
                            <label className='select-container'>
                                Modello
                                <Select
                                    className='select-item'
                                    options={modelOptions}
                                    value={productModel}
                                    onChange={handleModelChange}
                                    isSearchable
                                    placeholder="Seleziona il modello"
                                    isDisabled={!flgModelEnabled}
                                />
                            </label>
                        </div>
                    </div>
                );
            case 1:
                return (
                    <div className="configurator-step">
                        <h3 style={{ textAlign: 'center' }}>CONFIGURA IL TUO KIT PER IMPIANTI DI CLIMATIZZAZIONE CANALIZZATI</h3>
                        <div className='radio-group'>
                            {
                                tipoSistema == 'canalizzato' &&
                                <div className={kitCategory === 'kitDistribuzione' ? 'radio-option elevation-2' : 'radio-option'}
                                    onClick={handleKitCategoryChange.bind(this, "kitDistribuzione")}>
                                    <div className='option-image-container'>
                                        <LazyLoadImage
                                            effect='blur'
                                            src={distribuzioneImg}
                                            alt="Kit Distribuzione"
                                            className="label-image"
                                        />
                                    </div>
                                    <div className="label-container">
                                        <label className="title-label">
                                            <input
                                                type="radio"
                                                name="kitCategory"
                                                value="kitDistribuzione"
                                                checked={kitCategory === 'kitDistribuzione'}
                                                onChange={handleKitCategoryChange.bind(this, "kitDistribuzione")}
                                                className="input-radio"
                                            />SOLO ELEMENTI DI DISTRIBUZIONE AERAULICA </label>
                                    </div>
                                </div>
                            }
                            <div className={kitCategory === 'kitMotorizzato' && flgKitCompleto ? 'radio-option elevation-2' : 'radio-option'}
                                onClick={handleKitCategoryChange.bind(this, "kitCompleto")}>
                                <div className='option-image-container'>
                                    <LazyLoadImage
                                        effect='blur'
                                        src={motorizzatiDistribuzioneImg}
                                        alt="Kit Completo"
                                        className="label-image"
                                    />
                                </div>
                                <div className="label-container">
                                    <label className="title-label">
                                        <input
                                            type="radio"
                                            name="kitCategory"
                                            value="kitCompleto"
                                            checked={kitCategory === 'kitMotorizzato' && flgKitCompleto}
                                            onChange={handleKitCategoryChange.bind(this, "kitCompleto")}
                                            className="input-radio"
                                        />SISTEMA COMPLETO<br />DISTRIBUZIONE AERAULICA + ELEMENTI MOTORIZZATI </label>
                                </div>
                            </div>
                            <div className={kitCategory === 'kitMotorizzato' && !flgKitCompleto ? 'radio-option first-option elevation-2' : 'radio-option first-option'}
                                onClick={handleKitCategoryChange.bind(this, "kitMotorizzato")}>
                                <div className='option-image-container'>
                                    <LazyLoadImage
                                        effect='blur'
                                        src={motorizzatiImg}
                                        alt="Kit Motorizzato"
                                        className="label-image"
                                    />
                                </div>
                                <div className="label-container">
                                    <label className="title-label">
                                        <input
                                            type="radio"
                                            name="kitCategory"
                                            value="kitMotorizzato"
                                            checked={kitCategory === 'kitMotorizzato' && !flgKitCompleto}
                                            onChange={handleKitCategoryChange.bind(this, "kitMotorizzato")}
                                            className="input-radio"
                                        />
                                        ELEMENTI MOTORIZZATI</label>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="configurator-step">
                        <h3>SELEZIONA IL NUMERO DI LOCALI DA CONTROLLARE </h3>
                        {
                            alertNumStacchi &&
                            (
                                <div className="alert-container">
                                    <div className='alert-text'>
                                        <div>
                                            <IoWarning className="text-icon-left" />
                                        </div>
                                        Il numero di stacchi selezionato non è sufficiente per smaltire la portata d’aria massima dell’unità interna selezionata.
                                        <div>
                                            <IoWarning className="text-icon-right" />
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        <div className='select-group' style={{ flexDirection: 'column' }}>
                            <label className='select-container multi-select'>
                                NUMERO DI LOCALI
                                <Select
                                    className='select-item'
                                    options={numberOfZonesOptions}
                                    value={{ value: numberOfZones, label: numberOfZones + ' LOCALI' }}
                                    defaultValue={{ value: numberOfZones, label: numberOfZones + ' LOCALI' }}
                                    onChange={handleNumberOfZonesChange}
                                    isSearchable={false}
                                    placeholder="Seleziona la marca"
                                    isDisabled={flgConf2}
                                />
                            </label>
                            {
                                tipoSistema == 'canalizzato' || tipoSistema == 'misto' ?
                                    <SelezioneStacchi numberOfZones={numberOfZones} codicePlenum={productModel.plenum} windowWidth={windowWidth} />
                                    : null
                            }
                        </div>
                    </div >
                );
            case 3:
                return (
                    <div className="configurator-step">
                        {
                            kitCategory == 'kitDistribuzione' ?
                                <div style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <h3>SELEZIONA L'ESTETICA DEL DIFFUSORE</h3>
                                    {
                                        alertPortataTerminale &&
                                        <div className="alert-container">
                                            <div className='alert-text'>
                                                <div>
                                                    <IoWarning className="text-icon-left" />
                                                </div>
                                                La portata d’aria nominale del singolo diffusore non soddisfa i parametri in relazione alla portata massima della macchina selezionata.
                                                È comunque possibile proseguire con la selezione. Per maggiori informazioni contattare l’ufficio tecnico.
                                                <div>
                                                    <IoWarning className="text-icon-right" />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        productModel.CodiceGriglia == productModel.CodiceGrigliaS &&
                                        (esteticaTerminale == 'PSB' || esteticaTerminale == 'PSD' || esteticaTerminale == 'PSF') &&
                                        <div className="alert-container">
                                            <div className='alert-text'>
                                                <div>
                                                    <IoWarning className="text-icon-left" />
                                                </div>
                                                Griglia a scomparsa non compatibile con le portate dell’unità interna selezionata.
                                                <div>
                                                    <IoWarning className="text-icon-right" />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <TerminalSelection />
                                </div>
                                :
                                <div>
                                    <h3>SELEZIONA LA TIPOLOGIA DI TERMOSTATI E LA COLORAZIONE</h3>
                                    <div className='radio-group' >
                                        <div className='secondary-image-container'>
                                            <img
                                                effect='blur'
                                                src={require(pathImmagini + "ICONA_APP.jpg")}
                                                alt={"ex"}
                                                className="secondary-image"
                                                style={{ marginLeft: '75px' }}
                                            />
                                        </div>
                                        <ComandiChoice commandColor={"bianchi"} impiantoType={"RADIO"} />
                                        <div className='secondary-image-container'>
                                            <img
                                                effect='blur'
                                                src={require(pathImmagini + "ICONA_RADIO.jpg")}
                                                alt={"ex"}
                                                className="option-middle-image"
                                            />
                                        </div>
                                        <ComandiChoice commandColor={"neri"} impiantoType={"RADIO"} />
                                        <div className='secondary-image-container'>
                                            <img
                                                effect='blur'
                                                src={require(pathImmagini + "ICONA_APP.jpg")}
                                                alt={"ex"}
                                                className="secondary-image"
                                                style={{ marginRight: '75px' }}
                                            />
                                        </div>
                                    </div>
                                    <div className='radio-group' >
                                        <div className='secondary-image-container'>
                                            <img
                                                effect='blur'
                                                src={require(pathImmagini + "ICONA_APP.jpg")}
                                                alt={"ex"}
                                                className="secondary-image"
                                                style={{ marginLeft: '75px' }}
                                            />
                                        </div>
                                        <ComandiChoice commandColor={"bianchi"} impiantoType={"FILO"} />
                                        <div className='secondary-image-container'>
                                            <img
                                                effect='blur'
                                                src={require(pathImmagini + "ICONA_FILO.jpg")}
                                                alt={"ex"}
                                                className="option-middle-image"
                                            />
                                        </div>
                                        <ComandiChoice commandColor={"neri"} impiantoType={"FILO"} />
                                        <div className='secondary-image-container'>
                                            <img
                                                effect='blur'
                                                src={require(pathImmagini + "ICONA_APP.jpg")}
                                                alt={"ex"}
                                                className="secondary-image"
                                                style={{ marginRight: '75px' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="guida-utente">
                                        <p>
                                            Il sistema prevede sempre un termostato per locale per la gestione delle temperature. Il KIT si compone di un comando MASTER (ETERNAL) con funzione di centralizzatore e i comandi SLAVE (SMART) .
                                        </p>
                                    </div>
                                </div>
                        }
                    </div>
                );
            case 4:
                return (
                    <div className="configurator-step">
                        {
                            flgKitCompleto ?
                                <div style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <h3>SELEZIONA L'ESTETICA DEL DIFFUSORE</h3>
                                    {
                                        alertPortataTerminale &&
                                        <div className="alert-container">
                                            <div className='alert-text'>
                                                <div>
                                                    <IoWarning className="text-icon-left" />
                                                </div>
                                                La portata d’aria nominale del singolo diffusore non soddisfa i parametri in relazione alla portata massima della macchina selezionata.
                                                È comunque possibile proseguire con la selezione. Per maggiori informazioni contattare l’ufficio tecnico.
                                                <div>
                                                    <IoWarning className="text-icon-right" />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <TerminalSelection />
                                </div>
                                :
                                null
                        }
                    </div>
                );
            case 100:
                return (
                    <div>
                        <h1>Configurazione terminata correttamente. Tornare su AppAgenti e premere il pulsante "SCARICA RIGHE"</h1>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className='configurator' ref={scrollableElementRef} >
            <div className="configurator-wrapper">
                {
                    step > 0 && step < 99 ?
                        <div className='progress-bar-container'>
                            <ProgressBar step={step} totalSteps={totalSteps} handleNext={handleNextStep}
                                handlePrevious={handlePreviousStep} flgConf2={flgConf2} kitCategory={kitCategory} />
                        </div>
                        : <div style={{ height: '20px' }} ></div>
                }
                <div className="configurator-container">
                    {
                        !isLoading ?
                            <div className="configurator-box">
                                {renderStepContent()}
                                <div className="buttons">
                                    <button
                                        className={step == 0 || (step < 3 && flgConf2 && kitCategory == 'kitMotorizzato')
                                            || (step < 5 && flgConf2 && kitCategory == 'kitDistribuzione') ?
                                            "button left invisible" : "button left"}
                                        onClick={step == 0 || (step < 3 && flgConf2 && kitCategory == 'kitMotorizzato')
                                            || (step < 5 && flgConf2 && kitCategory == 'kitDistribuzione') ?
                                            null : handlePreviousStep}>
                                        <BsArrowLeftShort className="text-icon-left" />
                                        Indietro
                                    </button>
                                    <button
                                        className="button right"
                                        onClick={handleNextStep}
                                    >
                                        {(flgKitCompleto && step == totalStepMot + 1) || (!flgKitCompleto && step == totalStepDis) ? 'Conferma' : 'Avanti'}
                                        {(flgKitCompleto && step == totalStepMot + 1) || (!flgKitCompleto && step == totalStepDis) ? <BsCheckLg className="text-icon-right" />
                                            : <BsArrowRightShort className="text-icon-right" />
                                        }
                                    </button>
                                </div>
                            </div>
                            :
                            <MyLoader active={true} color="#98c424" />
                    }
                </div>
                {
                    step > 1 && tipoImpianto != "" ?
                        <div className="configurator-container">
                            <div className="configurator-box">
                                {
                                    step >= 3 && kitCategory == 'kitMotorizzato' || (kitCategory == 'kitDistribuzione' && flgConf2) ?
                                        <Canvas
                                            ref={canvasRef}
                                            width={windowWidth < 800 ? 300 : windowWidth < 1200 ? 600 : windowWidth < 1400 ? 1000 : windowWidth < 1700 ? 1200 : windowWidth < 2000 ? 1400 : 1600}
                                            step={step}
                                            coloreComandi={coloreComandi}
                                            tipoSistema={tipoSistema}
                                            tipoImpianto={tipoImpianto}
                                            numberOfZones={numberOfZones}
                                            numTotaleStacchi={numTotaleStacchi}
                                            numLocaliPavRadiante={numLocaliPavRadiante}
                                            tipoInterfaccia={tipoInterfaccia}
                                            flgPavimentoRadiante={flgPavimentoRadiante}
                                            portataMax={productModel.portataMax}
                                            flgKitSani={flgKitSani} />
                                        : null
                                }
                            </div>
                        </div>
                        : null}
                <button
                    className="button red"
                    style={{ margin: 25 }}
                    onClick={() => { window.location.href = "https://configuratore-idema.csd-hosting.it/?success=false" }}
                >
                    Chiudi Configuratore
                    <IoCloseCircle className="text-icon-right" />
                </button>
            </div>
            <Modal
                isOpen={modalError.flgModal}
                onRequestClose={() => setModalError({ flgModal: false, titolo: "", testo: "" })}
                className="error-modal"
                contentLabel="Example Modal"
                ariaHideApp={false}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.4)', // Cambia l'opacità per aumentare l'oscuramento
                        zIndex: 10,
                    },
                    content: {
                        zIndex: 11,
                    },
                }}
            >
                <div>
                    <IoClose
                        className="close-icon"
                        onClick={() => setModalError({ flgModal: false, titolo: "", testo: "" })}
                    />
                </div>
                <div className="error-modal-title">
                    {modalError.titolo} <IoWarning className="text-icon-right" />
                </div>
                <div>{modalError.testo}</div>
            </Modal>
            <Modal
                isOpen={modalConferma.flgModal}
                onRequestClose={closeModalConferma}
                className="info-modal"
                contentLabel="Example Modal"
                ariaHideApp={false}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.4)', // Cambia l'opacità per aumentare l'oscuramento
                        zIndex: 10,
                    },
                    content: {
                        zIndex: 11,
                    },
                }}
            >
                <div>
                    <IoClose
                        className="close-icon"
                        onClick={closeModalConferma}
                    />
                </div>
                <div className="info-modal-title">{modalConferma.titolo}<IoMail className="text-icon-right" /></div>
                <div>{modalConferma.testo}</div>
            </Modal>
        </div >
    );
};

export default Configurator;

